import React, { useEffect, useState } from "react";

import { Collapse, Progress } from "antd";

import dayjs from "dayjs";
import "./linkpage.scss";

const { Panel } = Collapse;

const Linktable = ({ linkInitiatives }) => {
  const linkData = (data) => {
    return (
      <div className="d-flex align-items-center">
        <div className="row m-0 flex-1">
          <div className="col-6 col-lg-3 col-sm-6 px-1 pb-2 pb-sm-2 pb-lg-0">
            <p className="f-14 f-w-500 txt-text-1 mb-0 mb-lg-1">
              {data.keyResult}
            </p>
          </div>
          <p className="col-6 col-lg-3 col-sm-6 px-1 pb-2 pb-sm-2 pb-lg-0 f-14 f-w-500 txt-text-1 mb-1 d-flex align-items-center">
            {data.startDate ? dayjs(data.startDate).format("D MMM YYYY") : "--"}{" "}
            <span> - </span>
            {data.endDate ? dayjs(data.endDate).format("D MMM YYYY") : "--"}
          </p>
          <p className="col-6 col-lg-3 col-sm-6 px-1 pb-2 pb-sm-2 pb-lg-0 f-14 f-w-500 txt-text-1 mb-1 d-flex align-items-center">
            {data.title}
          </p>
          <p className="col-6 col-lg-3 col-sm-6 px-1 pb-2 pb-sm-2 pb-lg-0 f-14 f-w-500 txt-text-1 mb-1 d-flex align-items-center">
            <Progress
              className="linkProgress"
              percent={parseFloat(data.completedPercentage)}
            />
          </p>
        </div>
      </div>
    );
  };

  return (
    <>
      <div>
        <div className="px-lg-4 pb-lg-4 px-0 pb-0">
          <div className="row m-0 link-initiative-main-header">
            <p className="col-6 col-lg-3 col-sm-6 px-1 pb-2 pb-sm-2 pb-lg-0 f-14 f-w-700 txt-text-1">
              Key Result
            </p>
            <p className="col-6 col-lg-3 col-sm-6 px-1 pb-2 pb-sm-2 pb-lg-0 f-14 f-w-700 txt-text-1">
              Start Date - End Date
            </p>
            <p className="col-6 col-lg-3 col-sm-6 px-1 pb-2 pb-sm-2 pb-lg-0 f-14 f-w-700 txt-text-1">
              Link Initiative
            </p>
            <p className="col-6 col-lg-3 col-sm-6 px-1 pb-2 pb-sm-2 pb-lg-0 f-14 f-w-700 txt-text-1">
              Completed Progress
            </p>
            <div className="col-lg-1"></div>
          </div>
          {linkInitiatives?.length !== 0 ? (
            linkInitiatives?.map((data, index) => {
              return <Panel header={linkData(data)} key={index}></Panel>;
            })
          ) : (
            <div className="empty-list-page">
              <p className="f-20 f-w-bold">No data Found</p>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Linktable;
